import { render } from "./ShowDiskaun.vue?vue&type=template&id=0fd02a76"
import script from "./ShowDiskaun.vue?vue&type=script&lang=js"
export * from "./ShowDiskaun.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__